import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/api/auth'
import store from '@/store'

import LoggedOut from '@/layouts/LoggedOut'
import LoggedIn from '@/layouts/LoggedIn'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: LoggedOut,
    children: [
      {
        path: '',
        name: 'Login',
        meta: { title: 'Inicio de sesión' },
        component: () => import(/* webpackChunkName: 'login' */ '@/views/Login')
      }
    ]
  },
  {
    path: '/ce-login',
    component: LoggedOut,
    children: [
      {
        path: '',
        name: 'CELogin',
        meta: { title: 'Inicio de sesión CE' },
        component: () => import(/* webpackChunkName: 'ce-login' */ '@/views/CE/Login')
      }
    ]
  },
  {
    path: '/reset-password-request',
    component: LoggedOut,
    children: [
      {
        path: '',
        name: 'ResetPasswordRequest',
        component: () => import(/* webpackChunkName: 'reset-password-request' */ '@/views/ResetPasswordRequest')
      }
    ]
  },
  {
    path: '/create-account',
    component: LoggedOut,
    children: [
      {
        path: '',
        name: 'CreateAccount',
        component: () => import(/* webpackChunkName: 'create-account' */ '@/views/CreateAccount')
      }
    ]
  },
  {
    path: '/password-recovery/:password_token',
    component: LoggedOut,
    children: [
      {
        path: '',
        name: 'PasswordRecovery',
        component: () => import(/* webpackChunkName: 'password-recovery' */ '@/views/PasswordRecovery')
      }
    ]
  },
  {
    path: '/password_recovery/:password_token',
    redirect: '/password-recovery/:password_token'
  },
  {
    path: '/terms-and-conditions',
    component: LoggedOut,
    children: [
      {
        path: '',
        name: 'TermsAndConditions',
        component: () => import(/* webpackChunkName: 'terms-and-conditions' */ '@/views/TermsAndConditions')
      }
    ]
  },
  {
    path: '/moves-list',
    component: LoggedIn,
    children: [
      {
        path: '',
        name: 'MovesList',
        meta: {
          title: 'Lista de Cruces',
          requiresAuth: true
        },
        component: () => import(/* webpackChunkName: 'moves-list' */ '@/views/MovesList')
      }
    ]
  },
  {
    path: '/ce-moves-list',
    component: LoggedIn,
    children: [
      {
        path: '',
        name: 'CEMovesList',
        meta: {
          title: 'Movimientos Recientes',
          requiresAuth: true
        },
        component: () => import(/* webpackChunkName: 'ce-moves-list' */ '@/views/CE/MovesList')
      }
    ]
  },
  {
    path: '/invoiceable-sales',
    component: LoggedIn,
    children: [
      {
        path: '',
        name: 'InvoiceableSales',
        meta: {
          title: 'Movimientos Facturables',
          requiresAuth: true
        },
        component: () => import(/* webpackChunkName: 'invoiceable-sales' */ '@/views/InvoiceableSales')
      }
    ]
  },
  {
    path: '/invoices',
    component: LoggedIn,
    children: [
      {
        path: '',
        name: 'Invoices',
        meta: {
          title: 'Facturas Disponibles',
          requiresAuth: true
        },
        component: () => import(/* webpackChunkName: 'invoices' */ '@/views/Invoices')
      }
    ]
  },
  {
    path: '/created-invoice',
    component: LoggedIn,
    children: [
      {
        path: '',
        name: 'CreatedInvoice',
        meta: {
          title: 'Factura Creada',
          requiresAuth: true
        },
        component: () => import(/* webpackChunkName: 'created-invoice' */ '@/views/CreatedInvoice')
      }
    ]
  },
  {
    path: '/vehicles',
    component: LoggedIn,
    children: [
      {
        path: '',
        name: 'Vehicles',
        meta: {
          title: 'Lista de vehiculos',
          requiresAuth: true
        },
        component: () => {
          if (store.getters['user/userIsCompanyType']) {
            return import(/* webpackChunkName: 'ce-vehicles' */ '@/views/CE/Vehicles')
          }

          return import(/* webpackChunkName: 'vehicles' */ '@/views/Vehicles')
        }
      }
    ]
  },
  {
    path: '/vehicle/:id',
    component: LoggedIn,
    children: [
      {
        path: '',
        name: 'Vehicle',
        meta: {
          title: 'Detalle de Vehículo',
          requiresAuth: true
        },
        component: () => import(/* webpackChunkName: 'vehicle' */ '@/views/Vehicle')
      }
    ]
  },
  {
    path: '/sale/:id',
    component: LoggedIn,
    children: [
      {
        path: '',
        name: 'Sale',
        meta: {
          title: 'Detalle de recarga',
          requiresAuth: true
        },
        component: () => import(/* webpackChunkName: 'sale' */ '@/views/Sale')
      }
    ]
  },
  {
    path: '/change-password',
    component: LoggedIn,
    children: [
      {
        path: '',
        name: 'ChangePassword',
        meta: {
          title: 'Cambiar Contraseña',
          requiresAuth: true
        },
        component: () => import(/* webpackChunkName: 'change-password' */ '@/views/ChangePassword')
      }
    ]
  },
  {
    path: '/ce-recharge',
    component: LoggedIn,
    children: [
      {
        path: '',
        name: 'CERecharge',
        meta: {
          title: 'Detalle de recarga',
          requiresAuth: true
        },
        component: () => import(/* webpackChunkName: 'ce-recharge' */ '@/views/CE/Recharge')
      }
    ]
  },
  {
    path: '/subusers',
    component: LoggedIn,
    children: [
      {
        path: '',
        name: 'Subusers',
        meta: {
          title: 'Administrar usuarios',
          requiresAuth: true
        },
        component: () => import(/* webpackChunkName: 'subusers' */ '@/views/CE/Subusers')
      }
    ]
  },
  {
    path: '/telepeaje_tag',
    component: LoggedOut,
    children: [
      {
        path: '',
        name: 'GuestTagRecharge',
        meta: {
          title: 'Recarga de TAG para Carril Ordinario Vehicular',
          requiredAuth: false
        },
        component: () => import('@/views/GuestTagRecharge')
      }
    ]
  },
  {
    path: '/telepeaje_card',
    component: LoggedOut,
    children: [
      {
        path: '',
        name: 'GuestCardRecharge',
        meta: {
          title: 'Recarga Tarjeta Acceso Digital Peatonal',
          requiredAuth: false
        },
        component: () => import('@/views/GuestCardRecharge')
      }
    ]
  },
  {
    path: '/guest/sale/:id',
    component: LoggedOut,
    children: [
      {
        path: '',
        name: 'GuestSale',
        meta: {
          title: 'Detalle de recarga',
          requiresAuth: false
        },
        component: () => import(/* webpackChunkName: 'guest-sale' */ '@/views/GuestSale')
      }
    ]
  }
]

const createRouter = () => new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes
})

const router = createRouter()

router.beforeEach(async (to, from, next) => {
  const hasToken = getToken()

  if (hasToken) {
    await store.dispatch('user/context')
  }

  if (to.meta.requiresAuth && !hasToken) {
    next({
      path: '/'
    })
  } else if (!to.meta.requiresAuth && hasToken) {
    if (to.name === 'TermsAndConditions' && !store.state.user.terms_accepted) {
      next()
    } else {
      next({
        path: 'vehicles'
      })
    }
  } else {
    next()
  }
})

export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
